import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { StrapiService } from './strapi.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  
  private loggedInSourceSubject$ = new BehaviorSubject<boolean>(this.defaultLoggedInState()); 
  loggedIn$ = this.loggedInSourceSubject$.asObservable();
    
  private userTokenSourceSubject$ = new BehaviorSubject<string>( localStorage.getItem('accessToken') || '' ); 
  userToken$ = this.userTokenSourceSubject$.asObservable();

  private siteEntryURISubject$ = new BehaviorSubject<string>(''); 
  siteEntryURI$ = this.siteEntryURISubject$.asObservable();

  constructor(  private router: Router,
                private injector: Injector,
  ) {}

  login( token: string ) {
    localStorage.setItem('accessToken', token);
    
    this.loggedInSourceSubject$.next(true);
    this.userTokenSourceSubject$.next(token);

    const entryURI = this.siteEntryURISubject$.getValue();
    this.clearEntryURI(); 

    if ( entryURI ) {
      this.router.navigateByUrl(entryURI);
    } else {
      this.router.navigate(['/']);
    }
  }

  logout() {
    // sessionStorage.removeItem('accessToken');
    localStorage.removeItem('accessToken');
    this.loggedInSourceSubject$.next(false);
    const strapiService = this.injector.get(StrapiService);

    strapiService.logout().subscribe({
          next: (response) => {
            // console.log( 'login response', response);
          },
          error: (error) => {
            console.error('Logout failed', error);
          }
        });
        
    this.router.navigate(['/login']); 
  }

  defaultLoggedInState(): boolean {
    const value = localStorage.getItem('accessToken');
    return value !== null && value !== undefined && value !== '';
  }

  setEntryURI(uri: string) {
    this.siteEntryURISubject$.next(uri);
  }

  clearEntryURI() {
    this.siteEntryURISubject$.next('');
  }

  
}
